import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { jaJP } from '@mui/x-date-pickers/locales';
import App from './App';
import { AuthProvider } from './contexts/AmplifyContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { ja as jaLocale } from 'date-fns/locale/ja';

createRoot(document.getElementById('root')).render(
	<StrictMode>
		<HelmetProvider>
			<LocalizationProvider
				adapterLocale={jaLocale}
				dateAdapter={AdapterDateFns}
				localeText={jaJP.components.MuiLocalizationProvider.defaultProps.localeText}>
				<SettingsProvider>
					<BrowserRouter>
						<AuthProvider>
							<App />
						</AuthProvider>
					</BrowserRouter>
				</SettingsProvider>
			</LocalizationProvider>
		</HelmetProvider>
	</StrictMode>
);
